import { useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { Points } from '../components/Points';
import { Question } from '../components/Question';
import { useGame } from '../contexts/GameContext';

export const Quizz = () => {
    const navigate = useNavigate();

    const { questions, points, updatePoints } = useGame();

    const [index, setIndex] = useState(0)
    const [showNext, setShowNext] = useState(false);

    const handleQuestionAnswered = (points: number) => {
        updatePoints(points);
        setShowNext(true);
    }

    const handleNext = () => {
        if (index === questions.length - 1) {
            navigate('/complete');
        } else {
            setIndex(index + 1);
        }
        setShowNext(false);
    }

    return (
        questions.length > 0 ? (
            <div className="quizz">
                <Points data={points} />
                <Question question={questions[index]} complete={handleQuestionAnswered} />

                <div className="questions-numbers">
                    <p>Pergunta {index + 1} de {questions.length}</p>
                </div>
                {showNext && (
                    <nav>
                        <button className="btn"onClick={handleNext}>Próxima pergunta</button>
                    </nav>
                )}
            </div>
        ) : (
            <Navigate to="/" />
        )
    )
};